'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsSha1Webpack = require('js-sha1-webpack');

var _jsSha1Webpack2 = _interopRequireDefault(_jsSha1Webpack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EMPTY_BYTES = [];

function createUintArrayFromString(string) {
  var result = new Uint8Array(string.length);

  for (var i = 0; i < string.length; i++) {
    result[i] = string.charAt(i).charCodeAt(0);
  }

  return result;
}

function nextKey(oldKey) {
  var nextKey = (0, _jsSha1Webpack2.default)(oldKey, true);
  nextKey = new Uint8Array(nextKey);
  return nextKey;
}

var ResourceDecrypter = function () {
  function ResourceDecrypter() {
    _classCallCheck(this, ResourceDecrypter);
  }

  _createClass(ResourceDecrypter, [{
    key: 'descramble',
    value: function descramble(input, key) {
      var i = 0;
      var bytesRead = -1;

      key = nextKey(key);

      for (var j = 0; j < input.length; j++) {
        var b = input[j] & 0xFF;

        bytesRead++;
        if (bytesRead === (key[i] & 0xFF)) {
          b ^= key[++i];
          bytesRead = -1;
          i++;

          if (i >= key.byteLength) {
            key = nextKey(key);
            i = 0;
          }
        }

        input[j] = b;
      }
    }
  }, {
    key: 'decrypt',
    value: function decrypt(bytes, resourceId, decryptionKeys) {
      var decryptionKey = this.getDecryptionKeyForResource(resourceId, decryptionKeys);
      this.descramble(bytes, decryptionKey);

      // After this method resource should be decrypted and
      // swfFile object can be created.
    }

    // This method reads string key and returns byte array.

  }, {
    key: 'getDecryptionKeyForResource',
    value: function getDecryptionKeyForResource(resourceId, decryptionKeys) {
      if (!resourceId) {
        return EMPTY_BYTES;
      }

      var firstChar = resourceId[0];
      var decryptionKey = decryptionKeys[firstChar];

      if (decryptionKey) {
        var decryptionKeyBytes = createUintArrayFromString(decryptionKey);

        return decryptionKeyBytes;
      }

      return EMPTY_BYTES;
    }
  }]);

  return ResourceDecrypter;
}();

exports.default = ResourceDecrypter;